import { defineStore } from "pinia";

export const useAddSell = defineStore('useAddSell', {
    state: () => {
      return {
        isSaved: false,  
      }
    },
    getters:{},
    actions: {
    }
  })